import {noop} from 'es-toolkit'
import {isEmpty} from 'es-toolkit/compat'
import {useFormik} from 'formik'
import invariant from 'invariant'

import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {closeModal} from '../../../redux/features/modal'

import preventDoubleClick from '../../../../../commons/src/services/prevent-double-click'
import * as optionApi from '../../../services/api/option'
import {SingleFormData, formDataToOptionRequest, initialValues} from '../../forms/options/utils'
import {toValidationSchema} from '../../utils/form'

import {ModalMeta, Option} from '../../../types'

import Button from '../../../../../commons/src/components/button'
import Headline from '../../../../../commons/src/components/headline'
import Modal from '../../../../../commons/src/components/modal'

import InfillsForm, {validationSchema} from '../../forms/options/infills/form'

type Props = {
  meta: ModalMeta
  onDone?: (infill: Option) => void
}

const CreateInfillModal = ({meta, onDone = noop}: Props) => {
  const dispatch = useAppDispatch()
  const provider = useAppSelector(state => state.core.provider)
  invariant(provider, 'Provider is missing.')

  const formik = useFormik<SingleFormData>({
    initialValues,
    validationSchema: toValidationSchema(validationSchema, [['basePrice', 'factor']]),
    onSubmit: async (values, actions) => {
      const infillRequest = formDataToOptionRequest(values, provider)

      try {
        const createdInfill = await optionApi.create(infillRequest)

        dispatch(closeModal())
        onDone(createdInfill)
      } catch (error) {
        actions.setFieldError('formikGeneral', (error as Error).message)
      }
    },
  })

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="Create new infill option" size="l" />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
          <Button
            disabled={formik.isSubmitting || (formik.submitCount > 0 && !isEmpty(formik.errors))}
            onClick={preventDoubleClick(() => formik.handleSubmit())}
          >
            Save
          </Button>
        </>
      }
    >
      <InfillsForm formik={formik} provider={provider} />
    </Modal>
  )
}

export default CreateInfillModal
